<template>
    <div>
        <div style="display: flex; border-radius: 8px; height: 60px; width: 180px; gap: 4px; border-radius: 8px;">

            <div @click="minus" style="border-top-left-radius: 8px; border-bottom-left-radius: 8px;" :style="{backgroundColor: btnBackground}" class="common_item_style">
                <img style="width: 12px;" :src="cnt >= minCnt + 1 ? require('@/assets/img/minus_on.png') : require('@/assets/img/minus_off.png')" alt="">
            </div>
            <div style="font-size: 14px; font-weight: 500;" :style="{backgroundColor: btnBackground}" class="common_item_style">{{ cnt }}명</div>

            <div @click="plus" style="border-top-right-radius: 8px; border-bottom-right-radius: 8px;" :style="{backgroundColor: btnBackground}" class="common_item_style">
                <img style="width: 12px;" :src="cnt === maxCnt ? require('@/assets/img/plus_off.png') : require('@/assets/img/plus_on.png')" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlusMinusBtn',
    props: {
        saveRecruit: {
            type: Function,
            default: () => { }
        },
        isDuplicate: {
            type: Boolean,
            default: false,
        },
        duplicateCnt: {
            type: [Number, String],
            default: -1
        },
        minCnt: {
            type: Number,
            default: 1
        },
        maxCnt: {
            type: Number,
            default: 10
        },
        btnBackground: {
            type: String,
            default: '#f5f5f5'
        }
    },
    data() {
        return {
            cnt: this.isDuplicate ? this.duplicateCnt : 1
        }
    },
    methods: {
        plus() {
            if (this.cnt === this.maxCnt) {
                return
            }
            this.cnt++
            this.saveRecruit(this.cnt)
        },
        minus() {
            if (this.cnt === this.minCnt) {
                return
            }
            this.cnt--
            this.saveRecruit(this.cnt)
        }
    },
    watch: {
        duplicateCnt(newVal) {
            this.cnt = newVal
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}

.common_item_style {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>